import React, { useState, useEffect } from 'react';
import api from './api';
import logo from './assets/emaxy_logo.jpg';
import { useNavigate } from 'react-router-dom';

export default function TicketForm() {
  const [filteredClients, setFilteredClients] = useState([]);
  const [search, setSearch] = useState('');
  const [form, setForm] = useState({
    nome: '',
    cognome: '',
    ragionesociale: '',
    email: '',
    telefono: '',
    oggetto: '',
    descrizione: '',
    priorita: 'Media',
    tipologia: 'disservizio',
  });
  const navigate = useNavigate();
  
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [ticketNumber, setTicketNumber] = useState(null);

  useEffect(() => {
  if (!user) {
    const timer = setTimeout(() => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      } else {
        navigate('/login');
      }
    }, 300); // attende leggermente per permettere a TokenHandler di salvare

    return () => clearTimeout(timer);
  }
  }, [user, navigate]);

  useEffect(() => {
    const fetch = async () => {
      if (search.length < 2) return setFilteredClients([]);
      try {
        const res = await api.get(`/api/clienti?q=${search}`);
        setFilteredClients(res.data);
      } catch (err) {
        console.error('Errore nel caricamento clienti', err);
      }
    };
    fetch();
  }, [search]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleClientSelect = (client) => {
    let telefonoPreferito = client.phonemobile;
    if (!telefonoPreferito || telefonoPreferito.trim() === '') {
      telefonoPreferito = client.phonebusiness && client.phonebusiness.trim() !== '' ? client.phonebusiness : client.faxbusiness;
    }

    const nomeCompleto = `${client.firstname || ''} ${client.lastname || ''}`.trim();
    const identificativo = nomeCompleto || client.companyname || '';

    setForm(prev => ({
      ...prev,
      nome: client.firstname || '',
      cognome: client.lastname || '',
      ragionesociale: client.companyname || '',
      email: client.email || '',
      telefono: telefonoPreferito || ''
    }));

    setSearch(identificativo);
    setFilteredClients([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

const nomeOperatore = user?.nome || '';
const cognomeOperatore = user?.cognome || '';

    // Costruzione dinamica oggetto e descrizione
    const prefissoOggetto = form.tipologia === 'reclamo' ? '[Segnalazione Reclamo]' : '[Segnalazione Disservizio]';
    const oggettoFinale = `${prefissoOggetto} - ${form.oggetto}`;
    const descrizioneFinale = `Contatto Telefonico cliente: ${form.telefono}
Contatto email cliente: ${form.email}
Tipologia : ${form.tipologia}

${form.descrizione}`;

    const payload = {
      nome: form.nome,
      cognome: form.cognome || form.ragionesociale,
      ragionesociale: form.ragionesociale,
      email: form.email,
      telefono: form.telefono,
      oggetto: oggettoFinale,
      descrizione: descrizioneFinale,
      priorita: form.priorita,
      tipologia: form.tipologia
    };

    try {
      const res = await api.post('/api/apri-ticket', payload);
      if (res.data && res.data.ActionID) {
        setTicketNumber(res.data.ActionID);
      } else {
        alert('Ticket aperto ma non � stato restituito un ActionID');
      }
    } catch (err) {
      console.error('? Errore apertura ticket:', err);
      alert('Errore apertura ticket');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
    navigate('/login');
  };

  const resetForm = () => {
    setForm({
      nome: '',
      cognome: '',
      ragionesociale: '',
      email: '',
      telefono: '',
      oggetto: '',
      descrizione: '',
      priorita: 'Media',
      tipologia: 'disservizio'
    });
    setSearch('');
    setFilteredClients([]);
    setTicketNumber(null);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <header
        className="py-4 px-6 flex justify-between items-center"
        style={{ backgroundImage: 'linear-gradient(to right, white 50%, #047857 100%)' }}
      >
        <div className="flex items-center gap-3">
          <img src={logo} alt="Emaxy logo" className="h-10" />
          <span className="text-xl font-bold text-green-800">Ticket System</span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-sm text-white">Benvenuto, {user?.nome} {user?.cognome}</span>
          <button onClick={handleLogout} className="text-white border border-white rounded px-3 py-1 hover:bg-white hover:text-green-700 transition">
            Logout
          </button>
        </div>
      </header>

      <div className="p-6 flex items-center justify-center">
        <div className="bg-white p-8 rounded-2xl shadow-md w-full max-w-2xl">
          <h1 className="text-2xl font-bold text-center mb-6 text-green-700">Apri un nuovo ticket</h1>

          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="col-span-2">
              <label className="block mb-1 font-medium">Cerca cliente (nome, cognome o ragione sociale)</label>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                placeholder="Scrivi per cercare..."
              />
              {filteredClients.length > 0 && (
                <ul className="border border-gray-300 rounded mt-1 bg-white max-h-40 overflow-y-auto">
                  {filteredClients.map((client, i) => (
                    <li
                      key={i}
                      onClick={() => handleClientSelect(client)}
                      className="p-2 cursor-pointer hover:bg-green-100"
                    >
                      {client.firstname} {client.lastname} - {client.companyname} ({client.email})
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div>
              <label className="block mb-1 font-medium">Email</label>
              <input name="email" value={form.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" placeholder="Email" />
            </div>

            <div>
              <label className="block mb-1 font-medium">Telefono</label>
              <input name="telefono" value={form.telefono} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" placeholder="Telefono" />
            </div>

            <div className="col-span-2">
              <label className="block mb-1 font-medium">Oggetto</label>
              <input name="oggetto" value={form.oggetto} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded" placeholder="Oggetto" required />
            </div>

            <div className="col-span-2">
              <label className="block mb-1 font-medium">Descrizione</label>
              <textarea name="descrizione" value={form.descrizione} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded h-24" placeholder="Descrizione dettagliata" required />
            </div>

            <div>
              <label className="block mb-1 font-medium">Priorit&#224;</label>
              <select name="priorita" value={form.priorita} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded">
                <option value="Alta">Alta</option>
                <option value="Media">Media</option>
                <option value="Bassa">Bassa</option>
              </select>
            </div>

            <div>
              <label className="block mb-1 font-medium">Tipologia</label>
              <select name="tipologia" value={form.tipologia} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded">
                <option value="disservizio">disservizio</option>
                <option value="reclamo">reclamo</option>
              </select>
            </div>

            <div className="col-span-2 flex justify-end gap-4">
  {ticketNumber ? (
    <button type="button" onClick={resetForm} className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-xl shadow">Nuovo Ticket</button>
  ) : (
    <button type="submit" className="bg-green-700 hover:bg-green-800 text-white px-6 py-2 rounded-xl shadow">Apri Ticket</button>
  )}
</div>
          </form>

          {ticketNumber && (
            <div className="mt-6 p-4 bg-green-100 border border-green-400 text-green-800 rounded text-center">
              Ticket aperto con successo!<br />Numero: <strong>{ticketNumber}</strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}